import lodashCloneDeep from 'lodash/cloneDeep'

export const setDirectoryInputActionType = 'setDirectoryInputActionType';

export function setDirectoryInputAction(isDirectoryInput) {
    return {
        type: setDirectoryInputActionType,
        payload: {
            isDirectoryInput: isDirectoryInput,
        }
    }
}

export function setDirectoryInputHandler(state, action) {
    const { isDirectoryInput } = action.payload;
    let newState = lodashCloneDeep(state);
    newState.isDirectoryInput = isDirectoryInput;
    return newState;
}
